import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tr-interactive"
export default class extends Controller {
  static values = {
    checkable: { type: Boolean, default: false },
    link: { type: String, default: null },
    form: { type: String, default: null },
    linkTurboFrame: { type: String }
  }

  get checkbox() { return this.element.querySelector('td input[type="checkbox"], th input[type="checkbox"]') }

  connect() {
    if (!this.element.querySelector('[cellinteractive]')) {
      this.#addLinkOnCells()
    }
  }

  #addLinkOnCells() {
    if (this.checkableValue) {
      this.#checkCheckboxPresence()
      this.functionBuildOverlay = this.#buildOverlayLabel
    }
    else if (this.formValue) {
      this.functionBuildOverlay = this.#buildOverlayButton
    }
    else {
      this.functionBuildOverlay = this.#buildOverlayLink
    }

    // add interactive element on all cells
    // prevent add interactive element if cell contains link or form, except
    // if cell has allow-interactive attribute
    this.element.querySelectorAll('td, th').forEach(td => {
      if (!td.hasAttribute('allow-interactive') && td.querySelector('a, form, input')) { return }

      td.setAttribute('cellinteractive', '')
      td.appendChild(this.functionBuildOverlay())
    })
  }

  #checkCheckboxPresence() {
    if (!this.checkbox) {
      throw new Error('Checkbox must be present')
    }
  }

  #buildOverlayLink() {
    const a = document.createElement('a')
    if (this.linkTurboFrameValue) {
      a.setAttribute('data-turbo-frame', this.linkTurboFrameValue)
    }
    a.href = this.linkValue
    return a
  }

  #buildOverlayLabel() {
    const label = document.createElement('label')
    label.htmlFor = this.checkbox.id
    return label
  }

  #buildOverlayButton() {
    const button = document.createElement('button')
    button.type = 'submit'
    button.setAttribute('form', this.formValue)
    return button
  }

}
